/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Household_Reason_Teen_GuardianInputs */

const fr_household_reason_teen_guardian = /** @type {(inputs: Household_Reason_Teen_GuardianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscris-toi pour l'accompagner`)
};

/**

* @param {Household_Reason_Teen_GuardianInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const household_reason_teen_guardian = /** @type {((inputs?: Household_Reason_Teen_GuardianInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_Reason_Teen_GuardianInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_household_reason_teen_guardian(inputs)
});